import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Box,
  Flex,
  Text,
  Badge,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  useMediaQuery,
} from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import {
  EffectFade,
  Navigation,
  Pagination,
  EffectCoverflow,
} from "swiper/modules";
import Navbar from "../components/nav/index";

const workExperience = [
  // {
  //   title: "Muneland",
  //   type: "Project",
  //   description:
  //     "Muneland dedicated and versatile full-stack software engineer, I bring a comprehensive skill set that bridges both front-end and back-end development, ensuring seamless integration and exceptional user experiences.",
  //   images: ["/projectImages/muneland_1.jpg", "/projectImages/muneland_2.jpg"],
  //   githubLink: "",
  // },
  {
    title: "The Leading Practice",
    type: "Product",
    description: [
      "An AI-powered marketing automation platform built as a microservices-based multi-tenant SaaS with three-level RBAC authorization using Supabase Auth and row-level security.",
      "My role: Architected an AI-powered conversation hub with unified messaging across email, SMS, and live chat. Engineered Gmail AI automation with RAG-based memory using Pinecone vector database for contextual responses. Leveraged CrewAI orchestration for dynamic AI agent tool execution, and developed intelligent task automation that converts conversations into actionable tasks with automated routing.",
    ],
    images: [
      "/projectImages/tlp_1.png",
      "/projectImages/tlp_2.png",
      "/projectImages/tlp_3.png",
      "/projectImages/tlp_4.png",
    ],
    githubLink: "",
  },
  {
    title: "SimplifyVms",
    type: "Product",
    description: [
      "SimplifyVMS is a microservices based architecture product for managing contingent workforce, SOW, and talent.",
      "My role: Worked on Front End, Backend Integrations (internal and external), Redesigned integration product architecture for load distribution via horizontal scalability as well as collaborated directly with major US-based clients including RXO, AMFAM, and Marriott.",
    ],
    images: [
      "/projectImages/Simplify_2.png",
      "/projectImages/Simplify_3.png",
      "/projectImages/Simplify_4.png",
      "/projectImages/Simplify_5.png",
      "/projectImages/Simplify_6.png",
      "/projectImages/Simplify_7.png",
      "/projectImages/Simplify_8.png",
      "/projectImages/Simplify_9.png",
      "/projectImages/Simplify_10.png",
      "/projectImages/Simplify_11.png",
    ],
    githubLink: "",
  },
  {
    title: "Relevic",
    type: "Product",
    description: [
      "A self-service no-code web personalisation tool that provides a complete suite to help create relevant & personalized web experiences",
      "My role: Developed a drag-and-drop canvas using React Flow and React DnD, adding A/B and multivariant testing features. Improved performance with Redux and RTK queries, and implemented analytics to track user interaction. Enhanced security with CSRF tokens, JWT, iframe restrictions, and a request limiter to prevent DDoS attacks.",
    ],
    images: [
      "/projectImages/Relevic_1.png",
      "/projectImages/Relevic_2.png",
      "/projectImages/Relevic_3.png",
    ],
    githubLink: "",
  },
];

const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

const Work = () => {
  const [isLargerThanMobileSize] = useMediaQuery("(min-width: 768px)");
  const [activeSlide, setActiveSlide] = useState(0);
  const [animationKey, setAnimationKey] = useState(0);
  const handleWorkNext = () => {
    if (activeSlide === workExperience.length - 1) {
      setActiveSlide(0);
    } else {
      setActiveSlide(activeSlide + 1);
    }
  };

  const handleWorkPrevious = () => {
    if (activeSlide === 0) {
      setActiveSlide(workExperience.length - 1);
    } else {
      setActiveSlide(activeSlide - 1);
    }
  };

  useEffect(() => {
    setAnimationKey((prevKey) => prevKey + 1);
  }, [activeSlide]);
  return (
    <Box
      backgroundColor={"#000000"}
      gap={20}
      minHeight={"100vh"}
      color={"gray.300"}
    >
      <Flex direction={"column"}>
        <Navbar />
        <Flex
          margin={{ base: 5, lg: 10, xl: 20 }}
          justifyContent={"space-between"}
          direction={isLargerThanMobileSize ? "row" : "column"}
          gap={isLargerThanMobileSize ? 0 : 10}
        >
          <Flex
            width={isLargerThanMobileSize ? "45%" : "100%"}
            direction={"column"}
            gap={6}
            alignItems={"center"}
          >
            <Flex
              gap={5}
              color={"black"}
              backgroundColor={"gray.100"}
              paddingX={14}
              paddingY={5}
              borderRadius={"md"}
              width={"100%"}
              direction={"column"}
              height={"100%"}
              key={animationKey}
              animation={`${fadeIn} 0.3s ease-in`}
            >
              <Flex justifyContent={"space-between"} alignItems={"center"}>
                <Text fontSize={"3xl"}>
                  {workExperience[activeSlide].title}
                </Text>
                <Badge
                  backgroundColor={"#34A9A7"}
                  color={"white"}
                  paddingX={3}
                  paddingY={1}
                  borderRadius={"sm"}
                >
                  {workExperience[activeSlide].type}
                </Badge>
              </Flex>

              {/* <Text>{workExperience[activeSlide].description}</Text> */}
              {workExperience[activeSlide].description.map((line, index) => (
                <Text key={index}>{line}</Text>
              ))}
            </Flex>
            <Flex gap={5}>
              <IconButton
                aria-label="Previous slide"
                icon={<ChevronLeftIcon />}
                onClick={handleWorkPrevious}
                _hover={{
                  transform: "scale(1.1)",
                  transition: "all 0.3s ease-in-out",
                }}
              />
              <IconButton
                aria-label="Next slide"
                icon={<ChevronRightIcon />}
                onClick={handleWorkNext}
                _hover={{
                  transform: "scale(1.1)",
                  transition: "all 0.3s ease-in-out",
                }}
              />
            </Flex>
          </Flex>

          <Flex width={isLargerThanMobileSize ? "50%" : "100%"} height={"50vh"}>
            <CoverFlowSwiper
              imagesList={workExperience[activeSlide].images}
              slide={activeSlide}
            />
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Work;

export const ImageSwiper = ({ imagesList, slide }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size={"6xl"} isCentered>
        <ModalOverlay />
        <ModalContent borderRadius={"lg"}>
          <ModalHeader>{workExperience[slide].title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody backgroundColor={"black"}>
            <>
              <Swiper
                navigation={true}
                modules={[Navigation]}
                className="mySwiper"
              >
                {imagesList.map((elem, index) => (
                  <SwiperSlide key={index}>
                    <Box
                      p={0}
                      marginBottom={6}
                      minWidth="33vw"
                      h="75vh"
                      bgImage={`url(${elem})`}
                      bgSize="cover"
                      bgPos="center"
                      bgRepeat="no-repeat"
                      borderRadius="md"
                      onClick={onOpen}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
        {imagesList.map((elem, index) => (
          <SwiperSlide key={index}>
            <Box
              _hover={{ cursor: "pointer" }}
              minWidth="33vw"
              h="40vh"
              bgImage={`url(${elem})`}
              bgSize="cover"
              bgPos="center"
              bgRepeat="no-repeat"
              borderRadius="md"
              onClick={onOpen}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export const WorkExperience = ({ workExperience }) => {
  return (
    <Flex
      width={"100%"}
      height={"100%"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <>
        <Swiper
          navigation={true}
          effect="fade"
          fadeEffect={{
            crossFade: true,
          }}
          autoplay={{
            delay: 3000,
          }}
          loop={true}
          modules={[EffectFade, Navigation]}
          className="mySwiper"
        >
          {workExperience.map((elem, index) => (
            <SwiperSlide key={index}>
              <Flex
                gap={5}
                backgroundColor={"gray.800"}
                paddingX={14}
                paddingY={5}
                borderRadius={"md"}
                width={"100%"}
                direction={"column"}
                height={"100%"}
              >
                <Flex justifyContent={"space-between"} alignItems={"center"}>
                  <Text fontSize={"3xl"}>
                    {" "}
                    {index + 1}. {elem.title}
                  </Text>
                  <Badge paddingX={3}>{elem.type}</Badge>
                </Flex>

                <Text>{elem.description}</Text>
              </Flex>
            </SwiperSlide>
          ))}
        </Swiper>
      </>
    </Flex>
  );
};

export const CoverFlowSwiper = ({ imagesList, slide }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size={"6xl"} isCentered>
        <ModalOverlay />
        <ModalContent borderRadius={"lg"}>
          <ModalHeader>{workExperience[slide].title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody backgroundColor={"black"}>
            <>
              <Swiper
                navigation={true}
                effect="coverflow"
                grabCursor={true}
                centeredSlides={true}
                slidesPerView="1"
                coverflowEffect={{
                  rotate: 50,
                  stretch: 0,
                  depth: 100,
                  modifier: 1,
                }}
                pagination={{
                  clickable: true,
                }}
                modules={[EffectCoverflow, Pagination, Navigation]}
                className="mySwiper"
              >
                {imagesList.map((elem, index) => (
                  <SwiperSlide key={index}>
                    <img src={elem} alt={""} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
        {imagesList.map((elem, index) => (
          <SwiperSlide key={index}>
            <Flex _hover={{ cursor: "pointer" }}>
              <img src={elem} alt={""} onClick={onOpen} />
            </Flex>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};
